import styled from "styled-components";

export const Container = styled.div`
    padding: 20px;
    width: 100%;
    
    @media (max-width: 850px) {
        padding: 20px 0px;
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    padding-bottom: 0;

    .titulo {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 8px;

        div {
            font-size: 18px;
            font-weight: 600;
            margin: 0;
            color: ${({ theme }) => theme.colors.c000000};
        }
    }
`;

export const ListaComentarios = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

export const Separator = styled.div`
    border-top: 1px solid ${({ theme }) => theme.colors.interfaceGray200 || '#E5E7EB'};
    margin: 24px 0;
`;

export const ButtonNovoComentario = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    height: 40px;
    padding: 0 1.25rem;
    border: 2px solid ${({ theme }) => theme.colors.primaryRed400 || '#E52940'};
    border-radius: 6px;
    background: ${({ theme }) => theme.colors.primaryRed400 || '#E52940'};
    color: ${({ theme }) => theme.colors.pureWhite || '#FFFFFF'};
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
    flex-shrink: 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

    &:hover {
        transform: scale(1.02);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
    }

    &:active {
        transform: translateY(1px);
    }

    &:focus {
        outline: 2px solid ${({ theme }) => theme.colors.primaryRed400 || '#E52940'};
        outline-offset: 2px;
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const SectionHeader = styled.div`
    margin-top: 24px;
    margin-bottom: 25px;
    padding-top: 20px;
    
    h3 {
        font-size: 14px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: ${({ theme }) => theme.colors.interfaceText600 || '#374151'};
        margin: 0;
    }
`;
